import { AnalyticsClient } from '@shared/services';
import { BUILD_ENVIRONMENT } from '@shared/types';

import Constants from '@/utils/constants';
import Api from '@/data';

const pfbAnalyticsClient = new AnalyticsClient({
	environment: Constants.BUILD_ENVIRONMENT as BUILD_ENVIRONMENT,
});

pfbAnalyticsClient.initFoxtrot({
	app: 'pb_web_analytics',
	customIngestionHandler: (data) => {
		const { payload } = data;
		return Api.sendFoxtrotEvents(payload);
	},
	flushInterval: 5,
});

export { pfbAnalyticsClient };
